import React, { useState } from 'react';
import Styles from './OpenFinanceOQueE.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';

function OpenFinanceOQueE() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);

  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="open-finance-o-que-e">
        <ContainerHome24>
          {typeof window === 'undefined' ? (
            <></>
          ) : (
            <>
              {width >= 992 && (
                <picture>
                  <source
                    type="image/webp"
                    srcSet="assets/open-finance/img-o-que-e-open-finance-desk.webp"
                  />
                  <source
                    type="image/png"
                    srcSet="assets/open-finance/img-o-que-e-open-finance-desk.png"
                  />
                  <img
                    src="assets/open-finance/img-o-que-e-open-finance-desk.png"
                    alt="Mulher usando notebook em ambiente doméstico, representando o uso do Open Finance Santander para conectar contas bancárias com segurança, acessar ofertas personalizadas, melhores taxas e portabilidade de crédito."
                    className="img-o-que-e-open-finance"
                  />
                </picture>
              )}
            </>
          )}
          <div className="o-que-e-conteudo">
            <img src="assets/open-finance/ic-open-finance.svg" alt="" />
            <h2 className="o-que-e-titulo">O que é Open Finance?</h2>
            <p className="o-que-e-texto">
              O Open Finance é uma autorização que permite que você compartilhe seus dados
              financeiros com diferentes instituições de forma simples e segura.
              <br />
              <br />
              Na Santander Financiamentos, você pode enviar os seus dados e contar com todas as
              vantagens que o Open Finance oferece.
            </p>
          </div>
        </ContainerHome24>
        {typeof window === 'undefined' ? (
          <></>
        ) : (
          <>
            {width < 500 && (
              <picture>
                <source
                  type="image/webp"
                  srcSet="assets/open-finance/img-o-que-e-open-finance.webp"
                />
                <source
                  type="image/png"
                  srcSet="assets/open-finance/img-o-que-e-open-finance.png"
                />
                <img
                  src="assets/open-finance/img-o-que-e-open-finance.png"
                  alt="Mulher usando notebook em ambiente doméstico, representando o uso do Open Finance Santander para conectar contas bancárias com segurança, acessar ofertas personalizadas, melhores taxas e portabilidade de crédito."
                  className="img-o-que-e-open-finance"
                />
              </picture>
            )}
            {width >= 500 && width < 992 && (
              <picture>
                <source
                  type="image/webp"
                  srcSet="assets/open-finance/img-o-que-e-open-finance-800.webp"
                />
                <source
                  type="image/png"
                  srcSet="assets/open-finance/img-o-que-e-open-finance-800.png"
                />
                <img
                  src="assets/open-finance/img-o-que-e-open-finance-800.png"
                  alt="Mulher usando notebook em ambiente doméstico, representando o uso do Open Finance Santander para conectar contas bancárias com segurança, acessar ofertas personalizadas, melhores taxas e portabilidade de crédito."
                  className="img-o-que-e-open-finance"
                />
              </picture>
            )}
          </>
        )}
      </section>

      <style jsx>{Styles}</style>
    </>
  );
}

export default OpenFinanceOQueE;
